"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_table_1 = require("@tanstack/react-table");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const components_1 = require("components");
const tooltip_icon_svg_1 = __importDefault(require("images/utility-icons/tooltip-icon.svg"));
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const _components_1 = require("./_components");
const useStatusModal_1 = __importDefault(require("./_hooks/useStatusModal"));
const TableSchedPend = ({ tableData, handleTableFilter, footerTotal, salesReportError, salesReportLoading, }) => {
    const { StatusModal, handleClick } = (0, useStatusModal_1.default)();
    // Table Columns
    const columnHelper = (0, react_table_1.createColumnHelper)();
    const columns = [
        columnHelper.accessor('id', {
            header: 'ID',
            enableHiding: true,
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('colCustomerName', {
            header: 'Customer',
            enableColumnFilter: true,
            meta: {
                className: 'col-200',
            },
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('colProgramProductType', {
            header: 'Product',
            enableColumnFilter: true,
            meta: {
                className: 'col-100',
            },
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('colTransactionType', {
            header: 'Type',
            enableColumnFilter: true,
            meta: {
                className: 'col-100',
            },
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('colStatus', {
            header: 'Status',
            enableColumnFilter: false,
            meta: {
                className: 'col-200',
            },
            cell: ({ row, getValue }) => {
                const value = getValue();
                return ((0, jsx_runtime_1.jsxs)("div", { className: "transaction-status", children: [(0, jsx_runtime_1.jsx)(_components_1.TDCellStatus, { value: value, row: row, handleClick: handleClick }), value === 'signed' && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizationTooltip, { displayed: true, message: `The transaction will be processed on ${(0, utils_1.formatDateFromISOtoUSdateString)(row.original.installmentServiceDate)}.`, children: (0, jsx_runtime_1.jsx)("img", { src: tooltip_icon_svg_1.default, alt: "tooltip", width: 16, height: 16 }) }))] }));
            },
        }),
        columnHelper.accessor('colAlphaeonAccountNumber', {
            header: 'Account# / Loan#',
            enableColumnFilter: false,
            meta: {
                className: 'col-200',
            },
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('colExpiresAt', {
            header: 'Expiration Date',
            enableColumnFilter: false,
            cell: ({ getValue, row }) => {
                const daysUntilExpire = row.original.daysUntilAuthExpiration;
                const expirationDate = getValue();
                return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)({
                        'expiration-date': true,
                        'warn-orange': row.original.colStatus !== 'signed' &&
                            daysUntilExpire <= 5 &&
                            daysUntilExpire > 2,
                        'danger-red': row.original.colStatus !== 'signed' && daysUntilExpire <= 2,
                    }), children: [expirationDate, row.original.colStatus !== 'signed' &&
                            daysUntilExpire <= 5 &&
                            expirationDate && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizationTooltip, { displayed: true, message: `The patient must sign the receipt by ${expirationDate}, otherwise the sale will be canceled and need to be reprocessed.`, children: (0, jsx_runtime_1.jsx)("img", { src: tooltip_icon_svg_1.default, alt: "tooltip", width: 16, height: 16 }) }))] }));
            },
        }),
        columnHelper.accessor('colEffectiveAt', {
            header: 'Date',
            enableColumnFilter: false,
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('colAmount', {
            header: 'Amount',
            enableColumnFilter: false,
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('colAction', {
            header: 'Action',
            enableColumnFilter: false,
            enableSorting: false,
            cell: (props) => (0, jsx_runtime_1.jsx)(_components_1.ColumnActions, { row: props.row }),
        }),
    ];
    // Table Data
    const TABLE_DATA = (0, react_1.useMemo)(() => {
        if (tableData && tableData.length > 0) {
            return tableData?.map((itm) => {
                return {
                    ...itm,
                    colCustomerName: `${itm?.name.firstName} ${itm?.name.lastName}`,
                    colProgramProductType: itm?.programProductType.toUpperCase(),
                    colTransactionType: itm?.transactionType.toUpperCase(),
                    colStatus: itm?.status,
                    colAlphaeonAccountNumber: itm?.alphaeonAccountNumber,
                    colEffectiveAt: itm?.effectiveAt
                        ? (0, utils_1.formatDateFromDB)(itm?.effectiveAt.split('T')[0])
                        : '',
                    colExpiresAt: (0, utils_1.formatDateFromDB)(itm?.authRequestExpiresAt?.split('T')[0]) ?? '',
                    colAmount: (0, utils_1.formatCurrency)(itm?.amount, 2),
                    colAction: '',
                };
            });
        }
        else {
            return [];
        }
    }, [tableData]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "dashboard__transactions m-t-50", children: [(0, jsx_runtime_1.jsx)("div", { className: "dashboard__transactions--title", children: "Scheduled Pending Transactions" }), (0, jsx_runtime_1.jsx)("div", { className: "dashboard__activities--table m-t-30 m-b-30", children: salesReportLoading || (!TABLE_DATA && !salesReportError) ? ((0, jsx_runtime_1.jsx)(components_1.Spinner, {})) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: salesReportError ? ((0, jsx_runtime_1.jsx)("div", { className: "empty-state-container", children: (0, jsx_runtime_1.jsx)(components_1.P, { className: "text-red", children: "Fetching transactions failed, please refresh" }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_components_1.FilterTransactions, { onSubmit: handleTableFilter }), TABLE_DATA && TABLE_DATA.length > 0 ? ((0, jsx_runtime_1.jsx)(components_1.DataTable, { nowrap: false, pageSize: 10, borderless: true, disableClickRow: true, bordered: true, striped: false, small: false, data: TABLE_DATA ?? [], columns: columns, hideColumns: { id: false }, rowId: "id", customFooter: (0, jsx_runtime_1.jsx)(_components_1.FooterTotal, { total: footerTotal }) })) : ((0, jsx_runtime_1.jsx)(_components_1.EmptyState, {}))] })) })) }), (0, jsx_runtime_1.jsx)(StatusModal, {})] }));
};
exports.default = TableSchedPend;
